import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
    groups : localStorage.getItem('groups') && JSON.parse(localStorage.getItem('groups'))  || [],
};

const module = {
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/groups/index.js